import { Injectable } from '@angular/core';
import { BrowserXhr } from '@angular/http';

@Injectable()
export class CredentialXhrService extends BrowserXhr {

  build(): any {
    let xhr = super.build();
    xhr.withCredentials = true;
    return <any>(xhr);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/etc/credentialxhr.service.ts